export const AI_AUDIT_FREQUENCY_PRESETS = [
  {
    key: 'all',
    label: '毎回',
    value: JSON.stringify({ aiAuditMaxArticles: '', aiAuditFrequencyDays: '' }),
  },
  {
    key: '10-7',
    label: '10記事/7日',
    value: JSON.stringify({ aiAuditMaxArticles: '10', aiAuditFrequencyDays: '7' }),
  },
  {
    key: '10-30',
    label: '10記事/30日',
    value: JSON.stringify({ aiAuditMaxArticles: '10', aiAuditFrequencyDays: '30' }),
  },
  {
    key: '10-90',
    label: '10記事/90日',
    value: JSON.stringify({ aiAuditMaxArticles: '10', aiAuditFrequencyDays: '90' }),
  },
  {
    key: '1-30',
    label: '1記事/30日',
    value: JSON.stringify({ aiAuditMaxArticles: '1', aiAuditFrequencyDays: '30' }),
  },
  {
    key: '1-90',
    label: '1記事/90日',
    value: JSON.stringify({ aiAuditMaxArticles: '1', aiAuditFrequencyDays: '90' }),
  },
]
